module.exports = __webpack_public_path__ + "static/media/errorHollowIcon.cd0559ac.svg";